import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../components/Layout";
import UsersContent from "../../components/Pages/Users";
import { useTranslation } from "react-i18next";

const { displayName } = config;

export default function Users(): React.ReactNode | null {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${displayName}: Users`;
  }, []);

  return (
    <Layout title="List of Managers">
      <div style={{ marginBottom: 0, width: "100%" }}>
        <UsersContent />
      </div>
    </Layout>
  );
}
